import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SharedModule } from 'src/shared/shared.module';

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss']
})
export class ImageViewerComponent implements OnInit {

  public imgSource: any;
  constructor(private modalController: ModalController, private shared: SharedModule) {}

  ngOnInit() {}

  closeModal() {
    this.modalController.dismiss();
  }
}
